import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UploadFormComponent } from './upload-form/upload-form.component';
import { DetailsComponent } from './document/details/details.component';
import { ListComponent } from './document/list/list.component';
import { SearchComponent } from './document/search/search.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginCallbackComponent } from './logincallback/logincallback.component';
import { TabsComponent } from './tabs/tabs.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'dashboard/document/:linkId', component: HomeComponent},
	{ path: 'dashboard/list/:linkId', component: HomeComponent},
	{ path: 'authentication', component: LoginComponent },
	{ path: 'authenticationcallback', component: LoginCallbackComponent },
	{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
